module.exports = __webpack_public_path__ + "static/media/logo.ee336201.png";